/**
 * @generated SignedSource<<129ef3e0699386733d5fadd30f7ae3ac>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type articleCorrectionsWidgetArticle$data = {
  readonly corrections: ReadonlyArray<{
    readonly correction: {
      readonly json: Schema | null;
    } | null;
    readonly timestamp: number;
  } | null> | null;
  readonly " $fragmentSpreads": FragmentRefs<"contentSchemaRenderContent">;
  readonly " $fragmentType": "articleCorrectionsWidgetArticle";
};
export type articleCorrectionsWidgetArticle$key = {
  readonly " $data"?: articleCorrectionsWidgetArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"articleCorrectionsWidgetArticle">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "articleCorrectionsWidgetArticle",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Correction",
      "kind": "LinkedField",
      "name": "corrections",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "FormattedValue",
          "kind": "LinkedField",
          "name": "correction",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "json",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "timestamp",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "contentSchemaRenderContent"
    }
  ],
  "type": "Article",
  "abstractKey": null
};

(node as any).hash = "16c3c61d9981cd7a82e28e58fbd55edb";

export default node;
